import React, { useState } from 'react';
import FireFetch from "../../Firebase/FireFetch";
import { message, Form, Input, Select } from "antd";
import { Button } from "evergreen-ui";
import { MDBCol } from "mdbreact";
import { useListVals } from "../../Firebase/databaseHooks";
import Firebase from "../../Firebase/Firebase";
import { getDatabase, ref, orderByChild, query, onValue } from "firebase/database";
import { getDownloadURL, getStorage, ref as storageRef, uploadBytes } from "firebase/storage";
import { v4 as uuidv4 } from 'uuid';
import { useAuth } from "../../AuthContext/AuthContext";
import { filterSelectOption, sortSelectOptions } from "../../utils/selectOptions.js";

const { TextArea } = Input;
var storage = getStorage(Firebase);
var db = getDatabase(Firebase);
const moment = require("moment");

const AddLesson = (props) => {
	const { canAccessModule } = useAuth();
	const canCreateLesson = canAccessModule("LESSONS", "create");
	const [languagesArray] = useListVals(ref(db, "talmidsdb/languages"))
	const [fileName, setFileName] = useState(null);
	const [themeFile, setThemeFile] = useState(null);
	const [showLoading, setShowLoading] = useState(false);
	const [dropCategories] = useListVals(ref(db, "talmidsdb/categories"))
	const [dropSubs] = useListVals(ref(db, "talmidsdb/subCategories"))

	const handleFileUpload = (e) => {
		setFileName(e.target.files[0]);
	}

	const themeUpload = (e) => {
		setThemeFile(e.target.files[0]);
	}

	const handleCreate = (values) => {
		if (!canCreateLesson) {
			message.error("You do not have permission to create lessons.");
			return;
		}

		setShowLoading(true);
		const theme = document.getElementById("lessonTheme").value;
		var timeStamp = moment().format("YYYY-MM-DDTh:mm:ss");
		var objectID = uuidv4();
		var repeated = false;

		onValue(query(ref(db, 'talmidsdb/lessons'), orderByChild('language')), function (snapshot) {
			var lesson = snapshot.val();
			if (lesson.lesson === values.title) {
				repeated = true;
			}
		})
		if (!repeated) {
			var object = {
				"lessonName": values.title ? values.title : "",
				"lessonCode": values.lessonID ? values.lessonID : "",
				"dateAdded": timeStamp,
				"lessonTheme": theme ?? values.lessonTheme,
				"lessonLevel": values.lessonLevel ? values.lessonLevel : "",
				"language": values.language ? values.language : "",
				"categories": values.category ? values.category : "",
				"subCategories": values.subcategory ? values.subcategory : "",
				"id": objectID,
				"lessonStatus": "draft"
			};
			const output = FireFetch.SaveTODB("lessons", objectID, object);
			output.then((result) => {
				if (result === "success") {
					const selectedLanguage = languagesArray?.find((item) => item.id === values.language);
					const selectedCategories = (dropCategories || [])
						.filter((item) => (values.category || []).includes(item.id))
						.map((item) => item.name)
						.filter(Boolean);
					const selectedSubcategories = (dropSubs || [])
						.filter((item) => (values.subcategory || []).includes(item.id))
						.map((item) => item.categoryName)
						.filter(Boolean);
					const createdLesson = {
						...object,
						languageName: selectedLanguage?.languageName || "",
						category: selectedCategories.join(", "),
						subCategory: selectedSubcategories.join(", "),
						theme: object.lessonTheme || "",
						owner: "",
						assignedTo: "",
						lessonImage: "",
					};
					FireFetch.addLog("Lessons", objectID, "Create");
					if (props.onLessonCreated) {
						props.onLessonCreated(createdLesson);
					}
					message.success("Lesson created successfully");
					setShowLoading(false);
					props.modal(false);
				} else {
					message.error("Unable to create lesson and error occurred :: " + result);
					setShowLoading(false);
				}
			});
			uploadBytes(storageRef(storage, "System/Lessons/" + objectID + "/lessonImage"), fileName)
				.then((item) => {
					getDownloadURL(item.ref)
						.then((url) => {
							var picObj = { lessonImage: url };
							FireFetch.UpdateInDB("lessons", objectID, picObj)
						}).catch(() => {
							console.log('Error downloading profile picture');
						})
				})
			uploadBytes(storageRef(storage, "System/Lessons/" + objectID + "/theme-file"), themeFile)
				.then(function (snapshot) {
					getDownloadURL(snapshot.ref)
						.then((url) => {
							var picObj = { lessonThemeImage: url };
							FireFetch.UpdateInDB("lessons", objectID, picObj)
						}).catch(() => {
							console.log('Error downloading profile picture');
						})
					console.log('Uploaded a blob or file!');
				});
		} else {
			message.error("A lesson with the same title and language already exists in the database");
			setShowLoading(false);
		}
	}

	return (
		<>
			<MDBCol md={12}>
				<Form
					layout="vertical"
					onFinish={handleCreate}
				>
					<Form.Item label="Title"
						name="title"
						rules={[{
							required: true,
							message: 'Please input lesson title!'
						}]}>
						<Input placeholder="enter lesson title"
							id="title" />
					</Form.Item>
					<Form.Item label="Category" name="category">
						<Select mode="multiple"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}
							placeholder="Select lesson category">
							{dropCategories?.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.label !== "All" ? item.name : null}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Sub-Category" name="subcategory">
						<Select
							mode="multiple"
							placeholder="Select lesson sub-category"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{dropSubs?.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.categoryName}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Theme">
						<Input placeholder="enter Theme" id="lessonTheme" />
					</Form.Item>
					<Form.Item label="Lesson Code"
						name="lessonID"
						rules={[{ required: true, message: 'Please input lesson Code!' }]}>
						<Input placeholder="Enter lesson Code" id="lessonID" />
					</Form.Item>
					<Form.Item label="Language"
						name="language">
						<Select placeholder="Select lesson language"
							showSearch
							optionFilterProp="children"
							filterOption={filterSelectOption}
							filterSort={sortSelectOptions}>
							{languagesArray?.map((item, index) => (
								<Select.Option key={index} value={item.id}>{item.languageName}</Select.Option>
							))}
						</Select>
					</Form.Item>
					<Form.Item label="Lesson Level"
						name="lessonLevel"
						rules={[{ required: true, message: "Please select lesson level" }]}
					>
						<Select placeholder="Select lesson level">
							{[{ label: "Level 1-Introduction", value: 1 },
							{ label: "Level 2-Intermediate", value: 2 }, { label: "Level 3-Advanced", value: 3 }]
								?.map((item, index) => (
									<Select.Option key={index} value={item.value}>{item.label}</Select.Option>
								))}
						</Select>
					</Form.Item>
					<Form.Item label="Lesson Image">
						<Input type="file"
							style={{ width: "100%" }}
							accept="image/*"
							onChange={handleFileUpload}
							placeholder="enter lesson image" id="phone" />
					</Form.Item>
					<Button
						appearance="warning"
						onClick={() => props.modal(false)}
						disabled={showLoading}
					>
						Cancel
					</Button>
					<Button appearance="primary" htmlType="submit" loading={showLoading} disabled={!canCreateLesson}>
						Create
					</Button>
				</Form>
			</MDBCol>
		</>
	)
}

export default AddLesson;
